import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { filter, sumBy } from "lodash";
import { ReactElement } from "react";

import {
  GetCampaignForViewQuery,
  InitialMessageSendFailureType,
} from "~frontend/__generated__/graphql";
import { noBorderBottomIf } from "~frontend/util/styling";

import { initialSendFailureLabels } from "./messageStatusBreakdown/SendStatusTable";
import { StatusTableHeaderCell } from "./messageStatusBreakdown/styles";

export default function CampaignInitialsStatusTable({
  initialSendFailures,
}: {
  initialSendFailures: NonNullable<
    GetCampaignForViewQuery["getCampaignByShortId"]["initialSendFailures"]
  >;
}): ReactElement {
  const failuresWithoutSuppressions = filter(
    initialSendFailures,
    f =>
      f.initialSendFailureType !=
      InitialMessageSendFailureType.ContactSuppressed
  );

  return (
    <>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Skipped Contacts
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <StatusTableHeaderCell>Status</StatusTableHeaderCell>
            <StatusTableHeaderCell>Contact Count</StatusTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell
              sx={noBorderBottomIf(failuresWithoutSuppressions.length > 0)}
            >
              Skipped
            </TableCell>
            <TableCell
              sx={noBorderBottomIf(failuresWithoutSuppressions.length > 0)}
            >
              {sumBy(failuresWithoutSuppressions, "count")}
            </TableCell>
          </TableRow>
          {failuresWithoutSuppressions.map(
            ({ initialSendFailureType, count }, idx) => (
              <TableRow key={initialSendFailureType}>
                <TableCell
                  sx={{
                    paddingLeft: "32px",
                    ...noBorderBottomIf(
                      idx !== failuresWithoutSuppressions.length - 1
                    ),
                  }}
                >
                  {initialSendFailureLabels[initialSendFailureType]}
                </TableCell>
                <TableCell
                  sx={noBorderBottomIf(
                    idx !== failuresWithoutSuppressions.length - 1
                  )}
                >
                  {count}
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>

      <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
        <Typography variant="body2Bold">Note:</Typography> if contacts received
        an error while sending, or were opted out at the time of sending, they
        will appear in the table above.
      </Alert>
    </>
  );
}
